export default "__VITE_ASSET__ea7fd91f__"